<template>
  <div>
    <el-table :data="tableData">
      <el-table-column prop="approvedAt" key="approvedAt" v-if="currStatus != '1'" label="审核时间"></el-table-column>
      <el-table-column prop="submitAt" key="submitAt" label="申请时间"></el-table-column>
      <el-table-column prop="appUserId" key="appUserId" label="user ID"></el-table-column>
      <el-table-column prop="mobile" key="mobile" label="手机号">
        <template slot-scope="scope">
          <el-link type="primary" @click="showMobile(scope.row)">{{ scope.row.mobile }}</el-link>
        </template>
      </el-table-column>
      <el-table-column prop="name" key="name" label="姓名"></el-table-column>
      <el-table-column prop="idNum" key="idNum" label="身份证号码"></el-table-column>
      <el-table-column prop="frontCardSide" key="frontCardSide" label="身份证照片1">
        <template slot-scope="scope">
          <el-link type="primary" @click="showIdCardImg(scope.row.sellerIdentityAuthId, 1)">查看图片</el-link>
        </template>
      </el-table-column>
      <el-table-column prop="existProductBrand" key="existProductBrand" label="身份证照片2">
        <template slot-scope="scope">
          <el-link type="primary" @click="showIdCardImg(scope.row.sellerIdentityAuthId, 2)">查看图片</el-link>
        </template>
      </el-table-column>
      <el-table-column label="身份证有效期" key="valiAt" v-if="currStatus != '1'">
        <template slot-scope="scope">
          {{ scope.row.validAt }}
        </template>
      </el-table-column>
      <el-table-column prop="saleAfterInfoVO" key="saleAfterInfoVO" label="售后信息" width="220px">
        <template slot-scope="scope">
          <p v-if="scope.row.saleAfterInfoVO">{{ scope.row.saleAfterInfoVO.regionStr }}，{{ scope.row.saleAfterInfoVO.address }}，{{ scope.row.saleAfterInfoVO.addressee }}，{{ scope.row.saleAfterInfoVO.mobile}}</p>
        </template>
      </el-table-column>
      <el-table-column key="status" label="状态">
        <template slot-scope="scope">
          <span v-if="scope.row.status == 1">待审核</span>
          <span v-if="scope.row.status == 2">审核通过</span>
          <span v-if="scope.row.status == 3">已拒绝</span>
        </template>
      </el-table-column>
      <el-table-column prop="rejectReason" key="rejectReason" label="拒绝原因" v-if="currStatus == '3'"></el-table-column>
      <el-table-column v-if="currStatus == '2'" prop="vendorName" key="vendorName" label="店铺名称"></el-table-column>
      <el-table-column label="操作" key="action">
        <template slot-scope="scope">
          <el-button v-if="scope.row.status == 1" size="mini" @click="updateItem(scope.row.sellerIdentityAuthId)" type="text">开通店铺</el-button>
          <el-button v-if="scope.row.status == 2" size="mini" @click="idNumAdd(scope.row)" type="text">补录身份证</el-button>
          <el-button v-if="scope.row.status == 1" size="mini" @click="rejectItem(scope.row)" type="text">拒绝</el-button>
        </template>
      </el-table-column>
      <el-table-column label="备注" key="remarks">
        <template slot-scope="scope">
          <div>
            <p v-if="scope.row.remarks && !scope.row.isEditComment">
              {{ scope.row.remarks }}
            </p>
            <el-button
              v-if="!scope.row.isEditComment"
              type="text"
              @click="enableEdit(scope.$index)"
            >
              {{ scope.row.remarks ? '编辑' : '添加' }}
            </el-button>
            <el-input
              type="textarea"
              v-if="scope.row.isEditComment"
              :rows="3" 
              placeholder="" 
              maxlength="100" 
              show-word-limit 
              resize="none" 
              v-model="scope.row.remarkEdit"
            ></el-input>
            <el-button
              type="text" 
              v-if="scope.row.isEditComment" 
              @click="saveComment(scope.$index)"
            >保存</el-button>
            <el-button 
              type="text" 
              v-if="scope.row.isEditComment" 
              @click="scope.row.isEditComment = false"
            >取消</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="tr"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageNum"
      :page-sizes="[10, 25, 50, 100]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>

    <!-- 补录身份证 -->
    <el-dialog
      title="补录身份证"
      :visible.sync="idNumAddDialog"
      width="400px"
      :before-close="handleClose"
    >
      <el-upload
        class="avatar-uploader"
        multiple
        :limit="1"
        :http-request="handleHttpRequestFront"
        action=""
        accept=".png,.jpg,.jpeg"
        :on-success="handleSuccessFront"
        :on-remove="onRemoveFront"
        :on-exceed="onExceedFront"
        :file-list="fileListJsonFront"
      >
        <img v-if="frontCardSide" :src="frontCardSide" class="avatar" />
        <el-button v-else type="text" class="cartButton"
          >上传身份证人像面</el-button
        >
      </el-upload>

      <el-upload
        class="avatar-uploader"
        multiple
        :limit="1"
        :http-request="handleHttpRequestBack"
        action=""
        accept=".png,.jpg,.jpeg"
        :on-success="handleSuccessBack"
        :on-remove="onRemoveBack"
        :on-exceed="onExceedBack"
        :file-list="fileListJsonBack"
      >
        <img v-if="backCardSide" :src="backCardSide" class="avatar" />
        <el-button v-else type="text" class="cartButton"
          >上传身份证国徽面</el-button
        >
      </el-upload>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="confirmAuth()">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="拒绝原因" :visible.sync="rejectDialogVisiable" width="400px" :close-on-click-modal="false">
      <el-input type="textarea" :rows="3" placeholder="请输入拒绝原因" v-model="rejectForm.rejectReason"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="rejectDialogVisiable = false">取 消</el-button>
        <el-button type="primary" @click="submitReject">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { formatDateTime } from "@/utils/functions";
import {
  getIdentityAuthList,
  identityAuthRemarks,
  sellerVendorCreate,
  authConfirm,
  getMobile,
  getIdCardImg,
  rejectSeller,
} from "./api";
import { fileUpload } from "../../api/merchants";
import Client from "@/utils/client.js";
export default {
  data() {
    return {
      pageNum: 1,
      pageSize: 25,
      tableData: [],
      total: 0,
      idNumAddDialog: false,
      sellerIdentityAuthId: "",
      appUserId: "",
      frontCardSide: "", // 身份证人像面，OSS地址
      backCardSide: "", // 身份证国徽面，OSS地址
      fileListJsonFront: [],
      fileListJsonBack: [],
      rejectDialogVisiable: false,
      rejectForm: {
        sellerIdentityAuthId: null,
        rejectReason: '',
      },
    }
  },
  props: ['queryForm', 'currStatus'],
  created() {
    this.getTableData()
  },
  methods: {
    confirmAuth() {
      // 确定身份证补录
      if (!this.frontCardSide) {
        this.$message.error("请上传身份证人像面！");
        return;
      }
      if (!this.backCardSide) {
        this.$message.error("请上传身份证国徽面！");
        return;
      }
      const data = {
        frontCardSide: this.frontCardSide,
        backCardSide: this.backCardSide,
        sellerIdentityAuthId: this.sellerIdentityAuthId,
        appUserId: this.appUserId,
      };
      authConfirm(data).then((res) => {
        console.log(res);
        if (res.data.success) {
          this.handleClose();
          this.$message.success("身份证补录成功！");
          this.getTableData();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    idNumAdd(row) {
      // 补录身份证打开dialog
      this.idNumAddDialog = true;
      this.sellerIdentityAuthId = row.sellerIdentityAuthId;
      this.appUserId = row.appUserId;
      this.frontCardSide = "";
      this.backCardSide = "";
    },
    handleClose() {
      this.sellerIdentityAuthId = "";
      this.appUserId = "";
      this.frontCardSide = "";
      this.backCardSide = "";
      this.idNumAddDialog = false;
      this.fileListJsonFront = [];
      this.fileListJsonBack = [];
    },
    handleHttpRequestFront(option) {
      return fileUpload().then((res) => {
        const client = Client(res.data.data),
          file = option.file;
        const random_name =
          new Date().getTime() +
          Math.random().toString() +
          "." +
          file.name.split(".").pop();
        return client.put("tmp/" + random_name, file);
      });
    },
    handleSuccessFront(res, file, fileList) {
      this.fileListJsonFront = fileList;
      this.frontCardSide = res.url;
      console.log(fileList, file, res);
    },
    onExceedFront() {
      this.$message("上限1个");
    },
    onRemoveFront(file, fileList) {
      this.fileListJsonFront = fileList;
      this.frontCardSide = "";
    },

    handleHttpRequestBack(option) {
      return fileUpload().then((res) => {
        const client = Client(res.data.data),
          file = option.file;
        const random_name =
          new Date().getTime() +
          Math.random().toString() +
          "." +
          file.name.split(".").pop();
        return client.put("tmp/" + random_name, file);
      });
    },
    handleSuccessBack(res, file, fileList) {
      this.fileListJsonBack = fileList;
      this.backCardSide = res.url;
    },
    onExceedBack() {
      this.$message("上限1个");
    },
    onRemoveBack(file, fileList) {
      this.fileListJsonBack = fileList;
      this.backCardSide = "";
    },
    enableEdit(idx) {
      this.tableData[idx].isEditComment = true;
      if (this.tableData[idx].remarks) {
        this.tableData[idx].remarkEdit = this.tableData[idx].remarks;
      }
    },
    async updateItem(id) {
      try {
        this.$store.commit("setPageLoading", true);
        const res = await sellerVendorCreate({ sellerIdentityAuthId: id })
        console.log(res);
        this.$store.commit("setPageLoading", false);
        if (res.success) {
          this.$message.success('开通成功')
          this.getTableData()
        } else {
          this.$message.error(`${res.error || res.message || res.msg || res.data}`)
        }
      } catch (error) {
        this.$message.error(`${error.message || error.msg || error.data}`)
        this.$store.commit("setPageLoading", false);
      }
    },
    async saveComment(idx) {
      try {
        this.$store.commit("setPageLoading", true);
        const data = this.tableData[idx];
        const res = await identityAuthRemarks({ 
          sellerIdentityAuthId: data.sellerIdentityAuthId, 
          remarks: data.remarkEdit,
        });
        this.$store.commit("setPageLoading", false);
        if (res.success) {
          this.tableData[idx].isEditComment = false;
          this.tableData[idx].remarks = this.tableData[idx].remarkEdit;
          this.getTableData();
        }
      } catch (error) {
        this.$store.commit("setPageLoading", false);
      }
    },
    async getTableData(isReset) {
      try {
        if (isReset) {
          this.pageNum = 1;
        }
        this.$store.commit("setPageLoading", true);
        const res = (await getIdentityAuthList({
          ...this.queryForm,
          pageNo: this.pageNum,
          pageSize: this.pageSize,
          status: this.currStatus,
        })).data;
        this.$store.commit("setPageLoading", false);
        this.total = res.total;
        this.tableData = (res.list || []).map(
          item => {
            return {
              ...item,
              submitAt: formatDateTime(item.submitAt, "yyyy-MM-dd HH:mm:ss"),
              approvedAt: formatDateTime(item.approvedAt, "yyyy-MM-dd HH:mm:ss"),
              isEditComment: false,
              remarkEdit: '',
            };
          });
      } catch (error) {
        this.$store.commit("setPageLoading", false);
      }
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      setTimeout(() => {
        this.getTableData();
      }, 0);
    },
    handleCurrentChange(pageNum) {
      this.pageNum = pageNum;
      this.getTableData();
    },
    showMobile(row) {
      getMobile(row.appUserId).then(res => {
        if (res.data && res.data.success) {
          this.$alert(`手机号：${res.data.data}`, '警告', {
            type: 'warning',
            confirmButtonText: '确定',
          });
        }
      });
    },
    showIdCardImg(sellerIdentityAuthId, type) {
      getIdCardImg(sellerIdentityAuthId, type).then(res => {
        if (res.data && res.data.data) {
          this.$viewerApi({
            images: [res.data.data],
          })
        } else {
          this.$message.error(res.data.message || '系统异常');
        }
      });
    },
    rejectItem(row) {
      this.rejectForm.sellerIdentityAuthId = row.sellerIdentityAuthId;
      this.rejectForm.rejectReason = null;
      this.rejectDialogVisiable = true;
    },
    submitReject() {
      if (!this.rejectForm.rejectReason || !this.rejectForm.rejectReason.trim()) {
        this.$message('请输入拒绝原因')
        return;
      }
      rejectSeller({
        sellerIdentityAuthId: this.rejectForm.sellerIdentityAuthId,
        rejectReason: this.rejectForm.rejectReason,
      }).then(res => {
        if (res.data && res.data.success) {
          this.$message.success('已拒绝');
          this.rejectDialogVisiable = false;
          this.getTableData();
        } else {
          this.$message.error(res.data.message || '系统异常');
        }
      })
    },
  }
}
</script>

<style lang="less" scoped>
.tr {
  margin-top: 10px;
  text-align: right;
}
.ml10 {
  margin-left: 10px;
}
/deep/ .avatar-uploader {
  text-align: center;
}
/deep/ .avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
/deep/ .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.cartButton {
  font-size: 14px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
/deep/ .el-table__body,
.el-table__footer,
.el-table__header {
  table-layout: unset;
}
</style>